import comp from "./DragHandle";
export default comp;
